var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var DefaultErrorFallback = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: solid 2px red;\n  padding: 20px;\n"], ["\n  border: solid 2px red;\n  padding: 20px;\n"])));
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map